import axios from "axios";

import { Environment } from "common";

const token = localStorage.getItem("auth_token");

if (!token) console.warn("[warn] Missing token");

const points = axios.create({
  baseURL: Environment.getEnvString("REACT_APP_API_POINTS"),
  headers: {
    "Content-Type": "application/json",
    Accept: "json",
    "x-gateway-apikey": Environment.getEnvString("REACT_APP_KEY_POINTS"),
  },
});

points.interceptors.request.use(
  async (config) => {
    const token = await localStorage.getItem("auth_token");

    if (token !== null) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

points.interceptors.response.use(
  (config) => config,
  (error) => Promise.reject(error)
);

export default points;
